(() => {
  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const initProductCards = (root = document) => {
    root.querySelectorAll('.product-card__media-link').forEach((link) => {
      const first = link.querySelector('.product-card__first');
      const second = link.querySelector('.product-card__second');
      link.classList.remove('pk9-has-secondary');
      if (!first || !second) return;

      const sameSource = (() => {
        try {
          const a = new URL(first.currentSrc || first.src, window.location.origin).pathname;
          const b = new URL(second.currentSrc || second.src, window.location.origin).pathname;
          return a === b;
        } catch (_) {
          return false;
        }
      })();
      if (sameSource) return;

      const validateSecond = () => {
        link.classList.toggle('pk9-has-secondary', second.complete && second.naturalWidth > 0);
      };
      validateSecond();
      second.addEventListener('load', validateSecond, { once: true });
      second.addEventListener('error', () => link.classList.remove('pk9-has-secondary'), { once: true });
    });
  };

  const partners = [
    { handle: 'althen-poker-club', title: 'Althen Poker Club', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-althen-poker-club.jpg?v=1785236144' },
    { handle: 'cp78', title: 'CP78 – Club Poker Achères', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-cp78-acheres.jpg?v=1785236151' },
    { handle: 'gap-poker-club', title: 'Gap Poker Club', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-gap-poker-club.jpg?v=1785236146' },
    { handle: 'holdem-azur-83', title: 'Holdem Azur 83', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-holdem-azur-83.jpg?v=1785236168' },
    { handle: 'hyeres-poker-club', title: 'Hyères Poker Club', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-hyeres-poker-club.jpg?v=1785236136' },
    { handle: 'marseille-holdem', title: 'Marseille Holdem', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-marseille-holdem.jpg?v=1785236142' },
    { handle: 'nice-hand-manosque', title: 'Nice Hand Manosque', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-nice-hand-manosque.png?v=1785236170' },
    { handle: '♠️-poker-club-dracenie-taradeau-var', title: 'Poker Club Dracénie', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-poker-club-dracenie.jpg?v=1785248547' },
    { handle: 'poker-cognac-grande-champagne', title: 'Poker Cognac Grande Champagne', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-pcgc.jpg?v=1785236156' },
    { handle: 'psl', title: 'Poker Stack Liberty', logo: 'https://cdn.shopify.com/s/files/1/1051/8849/1528/collections/logo-poker-stack-liberty.png?v=1785236139' }
  ];

  const partnerHref = (handle) => `${window.PK9_ROUTES?.root || '/'}collections/${encodeURIComponent(handle)}`;

  const setPartnerLogo = (card, partner) => {
    const media = card.querySelector(':scope > div');
    if (!media) return;
    let img = media.querySelector('img');
    if (!img) {
      media.innerHTML = '';
      img = document.createElement('img');
      media.appendChild(img);
    }
    img.src = partner.logo;
    img.srcset = '';
    img.sizes = '';
    img.alt = partner.title;
    img.loading = 'lazy';
    img.decoding = 'async';
  };

  const makePartnerCard = (partner) => {
    const card = document.createElement('a');
    card.className = 'pk9n-logo pk9n-reveal is-visible';
    card.href = partnerHref(partner.handle);
    card.dataset.pk9Partner = partner.handle;

    const media = document.createElement('div');
    const img = document.createElement('img');
    img.src = partner.logo;
    img.alt = partner.title;
    img.loading = 'lazy';
    img.decoding = 'async';
    media.appendChild(img);

    const footer = document.createElement('footer');
    const meta = document.createElement('small');
    meta.textContent = 'CLUB PARTENAIRE';
    const title = document.createElement('strong');
    title.textContent = partner.title;
    const cta = document.createElement('span');
    cta.textContent = 'Voir la collection ↗';
    footer.append(meta, title, cta);
    card.append(media, footer);
    return card;
  };

  const initPartners = () => {
    const rail = document.querySelector('.pk9n-clubs .pk9n-rail.logos');
    if (!rail) return;

    partners.forEach((partner) => {
      const wantedTitle = normalize(partner.title);
      const card = [...rail.querySelectorAll('.pk9n-logo')].find((candidate) => {
        const href = (() => {
          try { return decodeURIComponent(new URL(candidate.href, window.location.origin).pathname); }
          catch (_) { return candidate.getAttribute('href') || ''; }
        })();
        const title = normalize(candidate.querySelector('footer strong')?.textContent);
        return href.includes(partner.handle) || title === wantedTitle || (partner.handle === 'cp78' && title === 'cp78');
      });

      if (card) {
        card.href = partnerHref(partner.handle);
        card.dataset.pk9Partner = partner.handle;
        setPartnerLogo(card, partner);
      } else {
        rail.appendChild(makePartnerCard(partner));
      }
    });
  };

  const largestImageSource = (img) => {
    const candidates = String(img.srcset || '')
      .split(',')
      .map((part) => {
        const bits = part.trim().split(/\s+/);
        const width = Number(String(bits[1] || '').replace('w', '')) || 0;
        return { src: bits[0], width };
      })
      .filter((item) => item.src);
    candidates.sort((a, b) => b.width - a.width);
    return candidates[0]?.src || img.src || img.currentSrc;
  };

  let zoomDialog;
  const getZoomDialog = () => {
    if (zoomDialog?.isConnected) return zoomDialog;
    zoomDialog = document.createElement('dialog');
    zoomDialog.className = 'pk9-zoom-dialog';
    zoomDialog.setAttribute('aria-label', 'Zoom photo produit');
    zoomDialog.innerHTML = `
      <div class="pk9-zoom-dialog__toolbar">
        <button class="pk9-zoom-dialog__close" type="button" aria-label="Fermer le zoom">×</button>
      </div>
      <div class="pk9-zoom-dialog__stage">
        <img class="pk9-zoom-dialog__image" alt="">
      </div>`;
    document.body.appendChild(zoomDialog);

    const close = () => zoomDialog.close();
    zoomDialog.querySelector('.pk9-zoom-dialog__close')?.addEventListener('click', close);
    zoomDialog.addEventListener('click', (event) => {
      if (event.target === zoomDialog) close();
    });
    zoomDialog.querySelector('.pk9-zoom-dialog__image')?.addEventListener('click', () => {
      zoomDialog.toggleAttribute('data-zoomed');
    });
    zoomDialog.addEventListener('close', () => {
      zoomDialog.removeAttribute('data-zoomed');
      document.body.classList.remove('pk9-zoom-open');
    });
    return zoomDialog;
  };

  const openZoom = (sourceImage) => {
    const dialog = getZoomDialog();
    const image = dialog.querySelector('.pk9-zoom-dialog__image');
    if (!image) return;
    image.src = largestImageSource(sourceImage);
    image.alt = sourceImage.alt || 'Photo produit';
    document.body.classList.add('pk9-zoom-open');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  const zoomIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="10.5" cy="10.5" r="5.75" stroke="currentColor" stroke-width="1.5"/>
      <path d="M15 15l4.25 4.25M10.5 8v5M8 10.5h5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`;

  const initProductZoom = (root = document) => {
    if (!document.body.classList.contains('template-product')) return;
    root.querySelectorAll('.product__media').forEach((media) => {
      if (media.dataset.pk9ZoomReady === 'true') return;
      const img = media.querySelector('img');
      if (!img) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pk9-product-zoom-button';
      button.setAttribute('aria-label', `Agrandir ${img.alt || 'la photo du produit'}`);
      button.innerHTML = zoomIcon;
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openZoom(img);
      });
      media.appendChild(button);
      media.dataset.pk9ZoomReady = 'true';
    });
  };

  const init = (root = document) => {
    initProductCards(root);
    initPartners();
    initProductZoom(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
